var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectronicMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.91666 13H5.41667C5.18655 13 5 13.1865 5 13.4167V14.25C5 14.4801 5.18655 14.6667 5.41667 14.6667H7.91666C8.14678 14.6667 8.33333 14.4801 8.33333 14.25V13.4167C8.33333 13.1865 8.14678 13 7.91666 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8607 1.63086L11.9923 1.63835C12.6425 1.71521 13.1494 2.3543 13.1494 3.13086C13.1494 3.90742 12.6425 13.4231 11.9923 13.5L11.8607 13.5075H7.43903C6.72684 13.5075 6.14941 3.95923 6.14941 3.13086C6.14941 2.30249 6.72684 1.63086 7.43903 1.63086H11.8607Z",
    fill: "#6DF0DE"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1,
    y: -1,
    width: 21.2993,
    height: 22.864
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_9308_7828_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9308_7828)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2993 4.56463C16.2993 3.70051 15.5988 3 14.7347 3H4.56463C3.70051 3 3 3.70051 3 4.56463V11.6054C3 15.0619 5.80203 17.8639 9.25851 17.8639H14.7347C15.5988 17.8639 16.2993 17.1634 16.2993 16.2993V4.56463Z",
    fill: "#6DF0DE",
    fillOpacity: 0.4
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12939 11.2141H8.47633H6.12939Z",
    fill: "#6DF0DE",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12939 11.2141H8.47633",
    stroke: "white",
    strokeWidth: 1.17347,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12939 7.69385H13.1702H6.12939Z",
    fill: "#6DF0DE",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12939 7.69385H13.1702",
    stroke: "white",
    strokeWidth: 1.17347,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9308_7828",
    x: -1,
    y: -1,
    width: 21.2993,
    height: 22.864,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9308_7828"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7828_clip_path",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2993 4.56463C16.2993 3.70051 15.5988 3 14.7347 3H4.56463C3.70051 3 3 3.70051 3 4.56463V11.6054C3 15.0619 5.80203 17.8639 9.25851 17.8639H14.7347C15.5988 17.8639 16.2993 17.1634 16.2993 16.2993V4.56463Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicMenu);
export default __webpack_public_path__ + "static/media/electronicMenu.5ce6ed8b18fc47e1c744a3eb10e52ef5.svg";
export { ForwardRef as ReactComponent };